import React from "react";
import HeroSection from "./herosection";
import StatsSection from "../Statsection/statsection";
import CoreServices from "../Services/Service/Services";
import RecentWorks from "../Recentwork/RecentWork";
import ProductsPage from "../Products/products";
import TestimonialsSection from "../Testmonials/Testimonials";
import JobOpeningsSection from "../Jopopening/jopopening";
import WorkProcessComponent from "../WorkProcess/workprocess";
import JobApplicationForm from "../Jopopening/applicationform";
import FAQ from "../Faq/faq";
import Info from "./info";
import GetInTouchForm from "../GetinTouchform/GetinTouch";
import HomeClientSection from "../Clientlist/clientlist";
import Readytostart from "../Products/readytostart";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import SEO from "../../AASeo/Seo";

const LandingPage = () => {
  const navigate = useNavigate();

  const handleNavigateToService = (serviceId) => {
    if (serviceId === "all") {
      navigate("/services");
    } else {
      navigate("/services", { state: { selectedServiceId: serviceId } });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleProductClick = (productId) => {
    navigate("/products", { state: { selectedProductId: productId } });
  };
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "IDLBAY Private Limited",
    alternateName: "IDLBAY",
    url: "https://idlbay.com",
    logo: "https://idlbay.com/idlbaylogo.png",
    sameAs: [
      "https://www.linkedin.com/company/idlbay/",
      "https://x.com/idlbayPvtLtd",
      "https://www.instagram.com/idlbay.official?igsh=dnIxMm50cmdxNDNy",
      "https://www.facebook.com/profile.php?id=61582746578911",
      "https://www.youtube.com/channel/UCDSb9__-mSLqeyuZYelakcw",
    ],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-9840841840",
      contactType: "Customer Support",
      areaServed: "IN",
      availableLanguage: ["English", "Tamil"],
    },
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Office No.1, First Floor, Door No.1, B Narasimhan 3rd Street",
      addressLocality: "T-Nagar, Chennai",
      addressRegion: "Tamil Nadu",
      postalCode: "600017",
      addressCountry: "IN",
    },
  };

  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <SEO
        title="IDLBAY | Premier IT Solutions & Digital Services"
        description="IDLBAY delivers comprehensive IT solutions including software development, web applications, mobile apps, digital marketing, and technology consulting services. Transform your business with our expert digital solutions."
        keywords="IT solutions, software development, web development, mobile app development, digital marketing, technology consulting, business automation, cloud solutions, IDLBAY, custom software development, ecommerce website design, SEO optimization, UI UX design, enterprise IT services, mobile app maintenance"
        url="https://idlbay.com/"
        organization={organization}
      />
      <section id="home" className="w-full overflow-x-hidden overflow-y-hidden">
        <HeroSection />
      </section>

      <div className="w-full overflow-x-hidden overflow-y-hidden">
        <Info />
      </div>

      <div className="w-full overflow-x-hidden">
        <StatsSection />
      </div>

      <section id="services" className="w-full overflow-x-hidden">
        <CoreServices onNavigateToService={handleNavigateToService} />
      </section>

      <div className="w-full overflow-x-hidden">
        <WorkProcessComponent />
      </div>

      <section id="portfolio" className="w-full overflow-x-hidden">
        <RecentWorks />
      </section>

      {/* <section id="products" className="w-full overflow-x-hidden">
                <ProductsPage onProductClick={handleProductClick} />
            </section> */}

      <div className="w-full overflow-x-hidden">
        <TestimonialsSection />
      </div>

      <div className="w-full overflow-x-hidden">
        <HomeClientSection />
      </div>

      <section id="blog" className="w-full overflow-x-hidden">
        <FAQ />
      </section>

      <div className="w-full overflow-x-hidden">
        <Readytostart />
      </div>
    </div>
  );
};

export default LandingPage;
